"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.relevancesStore = exports.DEFAULT_RELEVANCE = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _BuildConstants = require("../../../utils/BuildConstants");

var _reflux = _interopRequireDefault(require("reflux"));

var _RelevancesStore = _interopRequireDefault(require("./Stores/RelevancesStore"));

var _RelevancesActions = _interopRequireDefault(require("./Stores/RelevancesActions2"));

var _HttpRequest = require("../../../utils/HttpRequest");

var _RegisterInstance = _interopRequireDefault(require("../RegisterInstance"));

var DEFAULT_RELEVANCE = 70;
exports.DEFAULT_RELEVANCE = DEFAULT_RELEVANCE;
var URLS = {
  RELEVANCES_FOR_ASPECT_BASE: '/api/v1/relevance/aspect',
  AVAILABLE_ASPECTS: '/api/v1/relevance/aspect',
  SUBSCRIBE: '/api/v1/relevance/aspect/{aspect}/subscribe',
  UNSUBSCRIBE: '/api/v1/relevance/aspect/{aspect}/unsubscribe'
};
var FAKED_RELEVANCES = [{
  fake: {
    relevances: {
      '!4': 70,
      '!4!3': 30,
      '!4!17': 70,
      '!4!18': 70,
      '!4!26': 70,
      '!4!27': 70,
      '!4!28': 70,
      '!4!29': 70,
      '!30': 70,
      '!30!31': 70,
      '!14': 70,
      '!14!15': 70,
      '!14!3': 70,
      '!16': 70,
      '!16!21': 70
    }
  }
}, {
  fake: {
    relevances: {
      '!4': 50,
      '!4!3': 70,
      '!4!17': 30,
      '!4!18': 30,
      '!4!26': 30,
      '!4!27': 60,
      '!4!28': 60,
      '!4!29': 70,
      '!30': 30,
      '!30!31': 70,
      '!14': -1,
      '!14!15': 70,
      '!14!3': 70,
      '!16': 70,
      '!16!21': 70
    }
  }
}, {
  fake: {
    relevances: {
      '!4': 20,
      '!4!3': 70,
      '!4!17': 70,
      '!4!18': 70,
      '!4!26': 70,
      '!4!27': 70,
      '!4!28': 70,
      '!4!29': 70,
      '!30': 50,
      '!30!31': 70,
      '!14': 80,
      '!14!15': 70,
      '!14!3': 70,
      '!16': 70,
      '!16!21': 70
    }
  }
}];
var FAKE_INDEX = 0;
/**
 * {RelevancesStore}
 */

var relevancesStore = _reflux["default"].initStore(_RelevancesStore["default"]);

exports.relevancesStore = relevancesStore;

var RelevancesService = /*#__PURE__*/function () {
  function RelevancesService() {
    (0, _classCallCheck2["default"])(this, RelevancesService);
  }

  (0, _createClass2["default"])(RelevancesService, [{
    key: "_registerForAspects",
    value: function () {
      var _registerForAspects2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(aspects) {
        var i, clientId, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                i = 0;

              case 2:
                if (!(i < aspects.length)) {
                  _context.next = 16;
                  break;
                }

                console.log("ResponseService: going to register for aspect ".concat(aspects[i]));
                _context.next = 6;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 6:
                clientId = _context.sent;
                console.log('_registerForAspects clientId', clientId);
                _context.next = 10;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.ECLOUD_HOST).concat(URLS.SUBSCRIBE.replace('{aspect}', aspects[i]), "?clientId=").concat(clientId), null, null, null, null, null);

              case 10:
                response = _context.sent;

                if (!(response.data.status !== 'success' && !response.data.data)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", _promise["default"].reject(new Error('the status of the request for response was not "success" or data was undefined')));

              case 13:
                i++;
                _context.next = 2;
                break;

              case 16:
                return _context.abrupt("return", _promise["default"].resolve());

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);
                console.error('error on registering for aspect:', _context.t0);
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 19]]);
      }));

      function _registerForAspects(_x) {
        return _registerForAspects2.apply(this, arguments);
      }

      return _registerForAspects;
    }()
    /**
     * first: retrieve all available aspects and keep only available relevances in loaded data (it might be that some disappear)
     */

  }, {
    key: "_retrieveAvailableAspectsFromServer",
    value: function () {
      var _retrieveAvailableAspectsFromServer2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var clientId, response, availableAspects;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 3:
                clientId = _context2.sent;
                console.log('_retrieveAvailableAspectsFromServer clientId', clientId);
                _context2.next = 7;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.ECLOUD_HOST).concat(URLS.AVAILABLE_ASPECTS, "?clientId=").concat(clientId), null, null, null, null, null);

              case 7:
                response = _context2.sent;
                response = response.data;

                if (!(response && response.status === 'success' && response.data)) {
                  _context2.next = 14;
                  break;
                }

                availableAspects = response.data.aspects;
                console.log({
                  availableAspects: availableAspects
                });

                _RelevancesActions["default"].setAvailableAspects(availableAspects);

                return _context2.abrupt("return", _promise["default"].resolve(availableAspects));

              case 14:
                return _context2.abrupt("return", _promise["default"].reject(new Error('request for available aspects wasn\'t answered with status === \'success\' or there was no data key')));

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](0);
                console.error('error retrieving available aspects:', _context2.t0);
                return _context2.abrupt("return", _promise["default"].reject(_context2.t0));

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 17]]);
      }));

      function _retrieveAvailableAspectsFromServer() {
        return _retrieveAvailableAspectsFromServer2.apply(this, arguments);
      }

      return _retrieveAvailableAspectsFromServer;
    }()
    /** update from server and overwrite local data and save it locally
     */

  }, {
    key: "_retrieveRelevancesFromServer",
    value: function () {
      var _retrieveRelevancesFromServer2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(aspect) {
        var clientId, relevancesPlain, relevances;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 2:
                clientId = _context3.sent;
                console.log('_retrieveRelevancesFromServer clientId', clientId);
                _context3.prev = 4;
                _context3.next = 7;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.ECLOUD_HOST).concat(URLS.RELEVANCES_FOR_ASPECT_BASE, "/").concat(aspect, "?clientId=").concat(clientId), null, null, null, null, null);

              case 7:
                relevancesPlain = _context3.sent;
                relevances = relevancesPlain.data;

                if (!(relevances.status === 'success' && relevances.data)) {
                  _context3.next = 13;
                  break;
                }

                console.log('received relevances from server: ', relevances.data);

                _RelevancesActions["default"].setRelevances(relevances.data);

                return _context3.abrupt("return", _promise["default"].resolve(relevances.data));

              case 13:
                return _context3.abrupt("return", _promise["default"].reject(new Error('the status of the request for relevances was not "success" or data was undefined')));

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](4);
                console.error('error on retrieving relevances from server:', _context3.t0);
                return _context3.abrupt("return", _promise["default"].reject(_context3.t0));

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[4, 16]]);
      }));

      function _retrieveRelevancesFromServer(_x2) {
        return _retrieveRelevancesFromServer2.apply(this, arguments);
      }

      return _retrieveRelevancesFromServer;
    }()
    /**
     *  first: register for channel
     *  second: read local data
     *  third: update data from server
     */

  }, {
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // read local data
                console.log('read local data in RelevanceService');
                _context4.prev = 1;
                _context4.next = 4;
                return relevancesStore.initFromPersistentStore();

              case 4:
                console.log('done reading local data from Relevance service');
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](1);
                // ignore error
                console.error('error loading relevances from persistent store', _context4.t0);

              case 10:
                _context4.prev = 10;
                console.log('Relevance Server start downloading from server');
                _context4.next = 14;
                return this.updateFromServer();

              case 14:
                console.log('Relevance Server done downloading from server');
                _context4.next = 20;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t1 = _context4["catch"](10);
                console.error('error downloading from Server (RelevanceService)', _context4.t1); // do nothing

              case 20:
                return _context4.abrupt("return", _promise["default"].resolve());

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 7], [10, 17]]);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "updateFromServer",
    value: function () {
      var _updateFromServer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var availableAspects, relevances;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                console.log('RelevanceService: start downloading available aspects');
                _context5.next = 4;
                return this._retrieveAvailableAspectsFromServer();

              case 4:
                availableAspects = _context5.sent;
                console.log('RelevanceService: done downloading available aspects');
                _context5.prev = 6;
                console.log('register for aspect');
                _context5.next = 10;
                return this._registerForAspects(availableAspects);

              case 10:
                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](6);
                // do nothing
                console.warn('could not subscribe for at least one aspect', _context5.t0);

              case 15:
                console.log('RelevanceService: start downloading relevances');
                relevances = null;

                if (!(availableAspects && availableAspects.length > 0)) {
                  _context5.next = 23;
                  break;
                }

                console.log('RelevanceService: really downloading relevances'); // relevances = await this._retrieveRelevancesFromServer(availableAspects[0])

                _context5.next = 21;
                return this._retrieveRelevancesFromServer('lru');

              case 21:
                relevances = _context5.sent;
                console.log('RelevanceService: done really downloading relevances');

              case 23:
                console.log('RelevanceService: done downloading relevances or skipped'); // RelevancesActions.setCurrentAspect(availableAspects[0])

                _RelevancesActions["default"].setCurrentAspect('lru');

                _RelevancesActions["default"].setAvailableAspectsAndRelevances(availableAspects, relevances);

                return _context5.abrupt("return", _promise["default"].resolve());

              case 29:
                _context5.prev = 29;
                _context5.t1 = _context5["catch"](0);
                console.error('couldn\'t update relevances from server', _context5.t1);
                return _context5.abrupt("return", _promise["default"].reject(_context5.t1));

              case 33:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 29], [6, 12]]);
      }));

      function updateFromServer() {
        return _updateFromServer.apply(this, arguments);
      }

      return updateFromServer;
    }()
  }, {
    key: "startFakingValues",
    value: function startFakingValues() {
      FAKE_INDEX = (FAKE_INDEX + 1) % FAKED_RELEVANCES.length;

      _RelevancesActions["default"].setRelevances(FAKED_RELEVANCES[FAKE_INDEX]);

      setInterval(function () {
        FAKE_INDEX = (FAKE_INDEX + 1) % FAKED_RELEVANCES.length;

        _RelevancesActions["default"].setRelevances(FAKED_RELEVANCES[FAKE_INDEX]);
      }, 10000);
    }
  }]);
  return RelevancesService;
}();

var INSTANCE = new RelevancesService();
var _default = INSTANCE;
exports["default"] = _default;